import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { routesMap } from "../../constants/routes";

export const FireBaseRoutes = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const mode = queryParams.get('mode');
    console.log('Mode:', mode);

    const navigate = useNavigate();
    useEffect(() => {
        if(mode === 'resetPassword') {
            navigate(routesMap.processForgotPassword.to+"/?"+window.location.search);
        }
    }, [mode]);

    return null;
}

